import React from 'react';
import PageHeaderTile from '../ui/PageHeaderTile';
import { FilePlus } from 'lucide-react';
import InvoiceForm from '../invoice-form/InvoiceForm';
import InvoicesHistory from '../invoices-history/InvoicesHistory';
import ExportDataTile from '../export-data/ExportDataTile';
import { useBankDetails } from '../../hooks/useBankDetails';
import { useInvoices } from '../../hooks/useInvoices';
import { useExports } from '../../hooks/useExports';
import { useInvoiceForm } from '../../hooks/useInvoiceForm';
import { useClientSearch } from '../../hooks/useClientSearch';
import LoadingOverlay from '../ui/LoadingOverlay';

function IssuePage({ tenantName }) {
    const bankDetails = useBankDetails();
    const { suggestions, showSuggestions, searchClients, clearSuggestions } = useClientSearch();
    const {
        invoices,
        sorting,
        setSorting,
        page,
        setPage,
        totalPages,
        totalElements,
        setSize,
        isLoading,
        createInvoice,
        updateInvoice,
        deleteInvoice,
        generatePdf,
        downloadPdf,
        downloadPdfBulk,
        filters,
        setFilters
    } = useInvoices(20);

    const { exportCsv, exportExcel, exportXml } = useExports();
    
    const {
        formData,
        items,
        handleInputChange,
        handleItemInputChange,
        addItemDiv,
        removeItemDiv,
        handleLoadInvoiceToForm,
    } = useInvoiceForm();

    const handleSubmit = async (e) => {
        e.preventDefault();
        await createInvoice(formData);
    };

    return (
        <div className="w-full max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8 flex flex-col gap-8">
            <LoadingOverlay isVisible={isLoading} message="Обработка на заявката..." />
            <PageHeaderTile title="Издаване на фактура" icon={FilePlus} />
            <InvoiceForm
                items={items}
                formData={formData}
                bankDetails={bankDetails}
                addItemDiv={addItemDiv}
                removeItemDiv={removeItemDiv}
                handleInputChange={handleInputChange}
                handleItemInputChange={handleItemInputChange}
                handleInvoiceSubmit={handleSubmit}
                searchClients={searchClients}
                suggestions={suggestions}
                showSuggestions={showSuggestions}
                clearSuggestions={clearSuggestions}
            />
            <InvoicesHistory
                invoices={invoices}
                page={page}
                setPage={setPage}
                totalPages={totalPages}
                totalElements={totalElements}
                setSize={setSize}
                handleGeneratePdf={generatePdf}
                handleDownloadPdf={downloadPdf}
                handleDownloadPdfBulk={downloadPdfBulk}
                handleLoadInvoiceToForm={handleLoadInvoiceToForm}
                handleDeleteInvoice={deleteInvoice}
                handleUpdateInvoice={updateInvoice}
                sorting={sorting}
                setSorting={setSorting}
                bankDetails={bankDetails}
                filters={filters}
                setFilters={setFilters}
            />
            <ExportDataTile 
                handleExportCsv={exportCsv} 
                handleExportExcel={exportExcel} 
                handleExportXml={exportXml}
            />
        </div>
    )
}

export default IssuePage;
